import { config } from "./config";

export const helpers = {
    enroll: async function () {
        console.log("enroll");
    },
    login: async function () {
        console.log("enroll");
    },
    RandomNumber: function (min: number, max: number): number {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1) + min);
    },
    getDocument: async function (month: string, user_id: string, document_id: string) {
        try {
            const url = `${config.api_url}/v2/wells-cargo/banks/getUserStatements`;
            const data = {
                documentType: "statement",
                month: month,
                user_id: user_id,
                document_id: document_id
            };

            const res = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            });

            if (res.ok) {
                console.log("download complete");
                return true;
            } else {
                console.error("Error: ", "download incomplete");
                return false;
            }
        } catch (error) {
            console.error({ "error": "Unexpected token in JSON at position 0" });
        }
    }
};
